import { tagPageview } from '../tagging'

export const tagSearchPage = () => {
  tagPageview({
    page_name: 'groupoffer/search',
  })
}

export const tagFlightOffersPage = () => {
  tagPageview({
    page_name: 'groupoffer/flight-offers',
  })
}

export const tagAncillariesPage = () => {
  tagPageview({
    page_name: 'groupoffer/ancillaries',
  })
}

export const tagBookerDetailsPage = () => {
  tagPageview({
    page_name: 'groupoffer/booker-details',
  })
}

export const tagGroupDetailsPage = () => {
  tagPageview({
    page_name: 'groupoffer/group-details',
  })
}

export const tagSummaryPage = () => {
  tagPageview({
    page_name: 'groupoffer/summary',
  })
}

export const tagConfirmationPage = () => {
  tagPageview({
    page_name: 'groupoffer/success',
  })
}
